/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
//console.log("Hello World! (from pb-blocks-salary-calculator-table block)");
/* eslint-enable no-console */


jQuery(document).ready(function($) {

var domain = pb.baseUrl;

$.renderSalaryInsightsEmbed = function (blockID, country, roles, seniority_level) {
    
    var api_url_get_currency_code = domain+"/wp-json/pb-widgets/v1/salary-calculator/countries/"+country;

    $.ajax({
        type: "GET",
        url:  api_url_get_currency_code,
        cache: false,
    })
    .then(response => {

        var currency = response['currency_code'];
        var country_name = response['country_name'];
        var country = response['country_code'];
        var salary_type = 'annual';
        var seniority = seniority_level ? seniority_level : 'middle';
        var role_title = "";
        var role_slug = "";

        $('#'+blockID).find('.pb-calculator-results .other-country .name').text(country_name);
        $('#'+blockID).find('.pb-calculator-results table tr td .value').text('');

        var api_url = domain+"/wp-json/pb-widgets/v1/salary-calculator/find/"+country+"/"+roles+"/"+salary_type+"/"+currency+"/"+seniority;

        return $.ajax({
            type: "GET",
            url:  api_url,
            cache: false,
        })
        .then(response => {

            role_title = Object.keys(response['results'])[0];
            //$('#'+blockID).find('.pb-calculator-results .job-title').text(role_title +" "+ seniority);
            $('#'+blockID).find('.pb-calculator-results .job-title').text(role_title);


            role_slug = response['filter']['role_slugs'][0];
            $('#'+blockID).find('.pb-calculator-results .cta-link').html('<a href="'+domain+'/role/'+role_slug+'">Explore more details</a>');

            //console.log(job_tile);

            for (var key in response['results']) {

              var ph_data = response['results'][key]['PH']['seniority_level'][seniority];
              var other_data = response['results'][key][country]['seniority_level'][seniority];
               
              var ph_cost = 'No Data Yet'; 
              if(ph_data !== undefined){
                ph_cost = parseFloat(ph_data.median).toLocaleString("en", {minimumFractionDigits: 0,maximumFractionDigits: 0}); 
              }

              var other_cost = 'No Data Yet'; 
              if(other_data !== undefined){
                other_cost = parseFloat(other_data.median).toLocaleString("en", {minimumFractionDigits: 0,maximumFractionDigits: 0}); 

              }

              var savings =  response['results'][key]['savings'];
              var savings_amount = parseFloat(savings.amount); 
              if(savings_amount > 0){
                savings_amount = currency+" "+savings_amount.toLocaleString("en", {minimumFractionDigits: 0,maximumFractionDigits: 0});
              }

              var savings_percentage = parseFloat(savings.percentage); 
              if(savings_percentage > 0){
                savings_percentage = savings_percentage.toLocaleString("en", {minimumFractionDigits: 0,maximumFractionDigits: 0});
              }


              //Update values
              $('#'+blockID).find('.pb-calculator-results table tr.other-country td .value').text(other_cost);
              $('#'+blockID).find('.pb-calculator-results table tr.ph-country td .value').text(ph_cost);
              $('#'+blockID).find('.pb-calculator-results table tr.savings-amount td .value').text(savings_amount);
              $('#'+blockID).find('.pb-calculator-results table tr.savings-percentage td .value').text(savings_percentage+"% Savings");

            }

            //$('#'+blockID).find('.pb-calculator-results .selected-role .selected_roles_embed_container').css('opacity', 1);  

            $.renderCountriesDropdown(blockID, country, roles, seniority);  //render dropdown delay


        })
        .catch(error => {
            console.log('Request failed! Please contact support.');
        }); 

            

    });
    
}


$.renderCountriesDropdown = function (blockID, selectedCountry, selectedJobRoles, selectedSenority) { //Render Coutry dropdown

    var api_countries_url = domain+"/wp-json/pb-widgets/v1/salary-calculator/countries";

    return $.ajax({
        type: "GET",
        url:  api_countries_url,
        cache: false,
    })
    .then(response => {       

        var country_dropdown = '<select name="country-switcher" class="country-switcher" data-block-id="'+blockID+'" data-job-role="'+selectedJobRoles+'" data-seniority-level="'+selectedSenority+'">';

        for (var key in response) {

            if(selectedCountry == response[key]['country_code']){
                country_dropdown += '<option value="'+response[key]['country_code']+'" selected>'+response[key]['country_name']+'</option>';
            }else{
                country_dropdown += '<option value="'+response[key]['country_code']+'">'+response[key]['country_name']+'</option>';
            }
           
        }

        //country_dropdown += '</select>';
        $('#'+blockID).find('.pb-calculator-results .country-dropdown').html(country_dropdown);


    })
    .catch(error => {
        console.log('Request failed! Please contact support.');
    });   

}


    // Select all elements with the class 'item'
    $(".pb-salary-calculator-block-wrapper").each(function() {
        // Get the value of the 'data-category' attribute
        var selected_block_id = $(this).attr("id");
        var selected_job_roles = $(this).data("job-role");
        var selected_seniority_level = $(this).data("seniority-level");
        var selected_country = $(this).data("country");


       var salary_results = `
            <div class="pb-calculator-results exclude">
           		<h2 class="job-title "></h2>
           		<table border="0">
                    <tr class="other-country">
                        <td>
                            <div class="label">
                                Annual Total Employee Cost at 
                                <div class="name country-dropdown"></div>
                            </div>
                        </td>
                        <td>
                            <span class="value"></span>
                        </td>
                        
                    </tr>
                    <tr class="ph-country">
                        <td>
                            <div class="label">
                                Annual Total Employee Cost with <b>Penbrothers</b>
                            </div>
                        </td>
                        <td>
                            <span class="minus">-</span> <span class="value"></span> 
                        </td>
                        
                        
                    </tr>
                    <tr class="savings-amount">
                        <td>
                            <b>Savings</b>
                        </td>
                        <td>
                            <span class="value"></span>
                        </td>
                        
                        
                    </tr>
                    <tr class="savings-percentage">
                        <td>
                            <p>Final salary may vary based on experience of candidates.</p>
                        </td>
                        <td>
                            <span class="value"></span>
                        </td>
                        
                    </tr>
                </table>
                <div class="cta-link"></div>
            </div>
       `; 

       $(this).append(salary_results);

       $.renderSalaryInsightsEmbed(selected_block_id, selected_country, selected_job_roles, selected_seniority_level); //load selected values

    });



    $("body").delegate('.pb-salary-calculator-block-wrapper select.country-switcher', "change", function() {    
        
        var selected_country = this.value;
        var selected_block_id = $(this).data("block-id");
        var selected_job_roles = $(this).data("job-role");
        var selected_seniority_level = $(this).data("seniority-level");

        $.renderSalaryInsightsEmbed(selected_block_id, selected_country, selected_job_roles, selected_seniority_level); //load selected values

    });

});